module.exports = __webpack_public_path__ + "img/serpi_main.8b755858.jpeg";